/**
 * El aviso de "este equipo esta en el taller" tiene DOS caminos hacia el
 * ticket: el campo de carga del mostrador (`agregarProducto` en `index.tsx`)
 * y el buscador global ⌘K (`agregarAVenta` en `buscador-context.tsx`). La
 * regla es una sola —se avisa, no se bloquea— y este hook la centraliza para
 * que no queden dos copias del mismo `toast` divergiendo con el tiempo.
 *
 * Es best-effort: si `useUsadosEnTaller` todavia no trajo datos o la consulta
 * fallo, el mapa queda vacio y simplemente no se avisa. No es motivo para
 * frenar la carga del producto.
 */
import { useCallback, useMemo } from "react";

import { indexarEnTaller } from "@/components/taller/logica";
import { useUsadosEnTaller } from "@/lib/queries";
import { toast } from "@/hooks/use-toast";

/**
 * El usado sin precio de venta (`usadoSinPrecio`) no entra al ticket: se
 * venderia al costo. Los dos caminos al ticket lo frenan con este mismo aviso.
 */
export function avisarUsadoSinPrecio(nombre: string): void {
  toast({
    title: "Este usado no tiene precio de venta",
    description: `${nombre} está cargado al costo, sin margen. Ponele precio en Inventario, en Usados, y después vendelo.`,
  });
}

export function useAvisoEnTaller(): (productoId: number) => void {
  const { data: enTallerPagina } = useUsadosEnTaller();
  const enTaller = useMemo(() => indexarEnTaller(enTallerPagina?.filas ?? []), [enTallerPagina]);

  return useCallback(
    (productoId: number) => {
      const t = enTaller.get(productoId);
      if (!t) return;
      toast({
        title: "Este equipo está en el taller",
        description: `${t.numero}. Se agrega igual: si ya volvió, cerrá la orden después.`,
      });
    },
    [enTaller],
  );
}
